import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthRequestModel } from 'src/app/models/auth/auth-request';
import { AuthServiceService } from 'src/app/services/auth-service/auth-service.service';
import { GlobalVariables } from 'src/app/shared-config/global-environment';
import swal from 'sweetalert2';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  date: Date = new Date();
  year?: number = this.date.getFullYear();
  validationForm!: UntypedFormGroup;
  passwordFieldType = 'password';
  minPasswordLength: number = GlobalVariables.minPasswordLength;
  constructor(private formBuilder: UntypedFormBuilder, private authService: AuthServiceService, private router: Router) { }

  ngOnInit() {
    this.resetForm();
  }
  resetForm() {
    this.validationForm = this.formBuilder.group({
      username: ['', [Validators.required]],
      password: ['', [Validators.required, Validators.minLength(this.minPasswordLength)]],
    });
  }
  async formSubmit(form: UntypedFormGroup) {
    form.markAllAsTouched();
    this.trimUsernameControl();

    if (form.invalid) {
      return;
    }
    const formValue = this.validationForm.value;

    const dto: AuthRequestModel = {
      username: formValue.username,
      password: formValue.password,
    };

    this.authService.login(dto).subscribe({
      next: (res) => {
        if (this.authService.isCmsAccessAllowed(res.user)) {
          this.authService.storeSession(res);
          this.router.navigateByUrl('/dashboard');
        } else {
          swal.fire({
            title: "Login Failed",
            text: 'Your account has been deactivated. Please contact manager for further assistance. Thank You!',
            customClass: {
              confirmButton: "btn btn-error",
            },
            icon: "error"
          });
        }
      }, error: (error) => {

        swal.fire({
          title: "Login Failed",
          text: error?.error?.errorMessage == null ?
            'Please Try Again' : error?.error?.errorMessage == 'User is disabled' ?
              'Your account has been deactivated. Please contact manager for further assistance. Thank You!' : error?.error?.errorMessage,
          customClass: {
            confirmButton: "btn btn-error",
          },
          icon: "error"
        });
      }
    })
  }

  togglePasswordFieldType() {
    if (this.passwordFieldType == 'password') {
      this.passwordFieldType = 'text';
    } else {
      this.passwordFieldType = 'password';
    }
  }

  private trimUsernameControl() {
    const usernameControl = this.validationForm.get('username');
    const trimmedUsername = (usernameControl?.value ?? '').trim();

    if (usernameControl && usernameControl.value !== trimmedUsername) {
      usernameControl.setValue(trimmedUsername);
    }
  }
}
